import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { initialQueryState, updateQueryStateTable } from 'enable-ui';

import { isEmpty } from 'lodash';

export const useUpdateQueryState = (tableKey: string, limit?: number) => {
  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);

  const params = Object.fromEntries(searchParams.entries());

  useEffect(() => {
    if (isEmpty(params)) {
      updateQueryStateTable(tableKey, { ...initialQueryState, limit: limit ?? 10, search: '' });
    } else {
      updateQueryStateTable(tableKey, params);
    }
  }, []);
};
